// @ts-expect-error - Automatic, Please fix when editing this file
const combineProductNames = (product, softBundleComplementaryProduct) => {
  const baseProductName = product?.name;
  const softBundleComplementaryProductName = softBundleComplementaryProduct?.name;
  return `${baseProductName} & ${softBundleComplementaryProductName}`;
};

export default combineProductNames;
